module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of title page.",
      "src": "image/Title_page.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "CIP-space-after"
  }, [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "CIP-space-after"
  }, [_vm._v("Text and photographs © 2022 Olivia Carney")]), _vm._v(" "), _c('p', {
    staticClass: "CIP-space-after"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', {
    staticClass: "CIP-space-after"
  }, [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("1.800.835.4993 orders")]), _vm._v(" "), _c('p', {
    staticClass: "CIP-space-after"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gibbs-smith.com",
      "target": "_blank"
    }
  }, [_vm._v("www.gibbs-smith.com")])]), _vm._v(" "), _c('p', {
    staticClass: "CIP-space-after"
  }, [_vm._v("Illustrations by Victoria Carney")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Editor: Gleni Bartels")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Art director: Ryan Thomann")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Production designer: Virginia Snow")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Production manager: Felix Gregorio ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP-space-after"
  }, [_vm._v("Production editor: Sue Collier")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Library of Congress Cataloging-in-Publication")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Names: Carney, Olivia, author.  ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Title: The art of the board : fun & fancy snack boards, recipes & ideas for entertaining all year / Olivia Carney.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Description: First edition. | Layton, Utah : Gibbs Smith, [2022]")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Identifiers: LCCN 2022005440 | ISBN 9781423661368 (hardcover) ISBN 9781423661375 (epub)")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Subjects: LCSH: Snack foods. | LCGFT: Cookbooks.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Classification: LCC TX740 .C376 2022 | DDC 641.5/3—dc23/eng/20220215")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022005440",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022005440")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Dedication"
  }, [_vm._v("To Chase, my forever partner in life, for making all this possible. Your patience, kindheartedness, and support know no bounds. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "Photo of dried citrus.",
      "src": "image/Dried_Citrus_2_P2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "contents"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/00_ArtOfTheBoard#_idTextAnchor000"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/00_ArtOfTheBoard#_idTextAnchor001"
    }
  }, [_c('span', {
    staticClass: "Ch1-Color-shift"
  }, [_vm._v("The Art of the Board")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor037",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Spring-SO"
  }, [_vm._v("Spring")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classy Crudité")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bountiful Berries")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Build-Your-Own Bloody Mary ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taste of the Mediterranean")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brimful Brunch Board")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C’est Charcuterie ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Towering Tea Party")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Board Built for Two")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Say “Cheez”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luck o’ the Irish ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easter Sunday Board ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Floral ")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor055",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Summer-SO"
  }, [_vm._v("Summer")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Melon Ball Salad Platter")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burrata & Heirloom Tomato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fun In the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summertime Citrus, Mozzarella & Prosciutto ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grill Master")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultimate Taco Tuesday")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sushi Board")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winery Tour To-Go Box")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Floral")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red, White & Berries ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’more, Please!")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIY Ice Cream Sundaes")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor071",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Fall-SO"
  }, [_vm._v("Fall")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afternoon Pick-Me-Up")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fall Harvest ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ooey-Gooey Fondue-y")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gourmet Grilled Cheese & Tomato Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spice, Spice, Baby")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toil & Treats ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Game Day Board")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Takeout It Up a Notch")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oktoberfest")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thanksgiving Leftovers ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thankful for Desserts ")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor088",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Winter-SO"
  }, [_vm._v("Winter")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Build-a-Bagel Board")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cozy Hot Cocoa Board")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Movie Night Board ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Very Fondue You")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ho-Ho-Holiday Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Happy Hour")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harry & David"), _c('span', {
    staticClass: "Registered-TM _idGenCharOverride-1"
  }, [_vm._v("®")]), _vm._v(" Gift Basket Board ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gift of Holiday Cheer ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Festival of De-Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O Christmas Cheese! ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gather Round Grazing Table")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ring In the New Year")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor102",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Drinks-Dips-SO"
  }, [_vm._v("Dips, Snacks, Cocktails & More")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herby Vegetable Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Hummus ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elote Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Spiced Nuts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Chickpeas")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Nuts ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Pickled Red Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon, Feta & Mint Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Fried Goat Cheese Balls")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lavender & Peach Crostini")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple & Butternut Squash Bruschetta with Honey Ricotta & Garlic Toasts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fig, Prosciutto & Goat Cheese Flatbreads")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cracker-Crusted Baked Mac & Brie ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Cherry & Brie Galettes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheese “Cake”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dried Citrus")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frosted Rosemary & Frosted Cranberries")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elderflower Gin Sour ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pretty Pink Lemonade Spritzer")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Old-Fashioned")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Cilantro Jalapeño Mezcal Margarita ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autumn Harvest Punch ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Rosemary & Royal Riviera Pear Bourbon Spritzer ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Witch’s Brew")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mulled Wine ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-21"
  }, [_c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Board Scraps Simmer Pot")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Ch1-Color-shift"
  }, [_vm._v("Hopeless Hostess Appendix")])])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Title",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "TXT1_DC-Intro"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("O")]), _vm._v("n Friday nights growing up, it was ritual for my family to sit down at our kitchen island and nosh on a cheese board together before heading out to dinner. Nothing fancy. My dad would peel open a block of Cooper Sharp American cheese, throw some banana peppers and a handful of pepperoni onto a wooden board, and grab a half-eaten bag of whole-grain crackers from the pantry. As we snacked on our little board of fridge-finds, we reminisced about our weeks, laughed at jokes pointed at each other, and enjoyed every minute spent around that island. While it may sound insignificant to some, the memories of those nights stay with me even to this day. Since then, I’ve always associated laughter, connection, and love with sitting around a platter of food. Sharing a meal together creates community and connectedness; it allows you to experience different cultures, build relationships, and find comfort in something so seemingly small. This is precisely why I’ve developed such a love for food boards. There’s really no simpler—or foolproof—way to create lasting memories than to gather around a strikingly arranged spread and share moments (and cheese) together.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("As I’ve gotten older, I’ve become more food-obsessed. I’d always dreamed of becoming a chef, and while that didn’t exactly pan out (probably for the best—let’s just say, handling stress isn’t my strong suit), I’ve been given the gift of sharing my food creations with so many friends online. I started an Instagram account in the winter of 2019 to share my love of cheese boards with hopes that a few people might indulge me. Fast-forward just two years later, and I have hundreds of thousands of cheese-loving, charcuterie rose–making friends! ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Sophia Loren once said, “Everything you see I owe to spaghetti.” In my case, everything you see I owe to cheese (which includes this book and my stretchy pants). My family still laughs at the fact that a girl who once thought flour was an appropriate substitute for powdered sugar as a topping for brownies could have a food blog. And even though I persevered, no matter how much I worked to perfect my kitchen craft, after that incident I was forever deemed “hopeless” when it came to cooking, hosting, and nearly anything of the sort. So what have I decided to do? I’m leaning into that shit. I’ve written this book for the other “hopeless” hostesses and hosts out there who have the passion to entertain but maybe not the prowess (yet!). This is why throughout the book, you’ll come across my scribbled Hopeless Hostess tips, which are essentially a peek into my brain. They’re the tricks I’ve accumulated over the years that will make your boards really shine. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "Photo of author.",
      "src": "image/NEW_Olivia_photo_P.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "credit"
  }, [_vm._v("Photograph by Kevin Morrissey.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "TXT"
  }, [_vm._v("I like to think of my cheese and snack boards as my own works of art: The board is my canvas, the vivid ingredients are my paint, and my hands are the brush. Sounds so tranquil, doesn’t it? Well, for me, it’s not—at least most of the time, anyway. While I would love to say that my process is full of serenity, it’s not always peaceful. (Especially when I’ve taken a huge chunk off the side of my hand with a cheese grater, which has happened twice!) But even if the process is frantic, getting creative in the kitchen allows me to express myself through food. It’s how I create food-inspired art, which is precisely why I named this book "), _c('em', {
    staticClass: "Emphasis"
  }, [_vm._v("The Art of the Board.")])]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("In addition to detailing everything you’ll need to plan and build unique cheese, charcuterie, and snack boards, I want to show you how to turn an everyday meal into an engaging experience for the people you’re sharing it with. Food boards are tactile (which is a fancy way of saying they’re an acceptable way to play with your food as a grown adult) and an immersive experience that brings people together. My only wish is that this book inspires you to carve out more time to enjoy the company of your family and friends and create lasting memories from small, intimate moments, just like the ones I had growing up.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Love and burrata,")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("  Liv")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Photo of a food board.",
      "src": "image/LIV-12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "credit"
  }, [_vm._v("Photograph by Kevin Morrissey.")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "CH-Number"
  }, [_c('span', {
    staticClass: "Ch1-Color-shift"
  }, [_vm._v("1 ")])]), _vm._v(" "), _c('p', {
    staticClass: "Ch-Subtitle",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "Ch1-Color-shift"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("The Art of")]), _c('span', {
    staticClass: "Ch1-Color-shift"
  }), _c('span', {
    staticClass: "Ch1-Color-shift"
  }, [_vm._v("the Board")])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Heading-1"
  }, [_vm._v("The "), _c('br'), _vm._v("Building Blocks "), _c('br'), _vm._v("of a Board")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1_DC"
  }, [_c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("L")]), _vm._v("et’s set a foundation before we jump into the actual board-making. In this section, we’re talking about everything you need to get off on the right foot, including equipment, board components, the basics of assembly, and how you can successfully use this book to bring your vision to life! You can consider this section your go-to resource for board preparation. Then, a little later in the book, we will cover the extra tips and tricks that will take your board from being simply drool-worthy to “I can’t even touch this because it’s so damn beautiful!” ")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "bpink"
  }, [_c('h2', {
    staticClass: "Heading-2"
  }, [_vm._v("The Board")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("It’s the twenty-first century, and you know the drill: We eat with our eyes first, so finding the right foundation for your food is more important than you might think. First, let’s consider the surface we’ll use to serve our food. Boards come in many different shapes and dimensions, but there are a few standard sizes that are helpful to have on hand. ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("A standard rectangular board is 9 by 13 inches, and a standard circular board is typically 15 inches in diameter. Throughout the book you’ll notice I use a variety of boards, depending on the occasion. For spreads meant to serve a smaller group, I opt for a board smaller than the standard size. Or if the board has a lot of freely placed items (items that are placed directly on the board, not in ramekins), I choose one with raised edges to keep the food in place. It’s important to consider both function and beauty when selecting a surface, but remember that the larger the board, the more expensive it will be to fill it! ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Ultimately, your boards are an investment, so you’ll want to take care of them. For detailed care instructions, take a look at "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Board Care 101")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "Photo of a food board with citrus on it.",
      "src": "image/DSC03217_P.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Ch1-Subhead"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("Wood ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("A wood board is like your favorite pair of flats: practical and reliable. I typically reach for a modern, minimalistic wood board that offers a bold grain and unique color, which keeps the spread from looking messy once a lot of the food is gone. I love the warmth that a wood board gives off. It’s important that you choose a good-quality non-porous hardwood, which is relatively easy to maintain and lasts a long time.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "Illustration of acacia wood.",
      "src": "image/Acacia_Wood.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1 boardtext"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Acacia: ")]), _vm._v("This wood has distinct graining with contrasting colors, making it one of the most popular and beautiful types of wood to use for snack boards. It’s also very durable, so you won’t need to worry about the damage from Aunt Judy digging her cheese knife aggressively into the Brie.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "Illustration of bamboo wood.",
      "src": "image/Bamboo_Wood.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1 boardtext"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Bamboo:")]), _c('strong', {
    staticClass: "Bold-lead-in2"
  }), _vm._v("An eco-friendly, du-rable, and surprisingly affordable option. Bamboo is not only remarkably sustainable but also stronger than most woods, which means that if you want your board to double as a cutting board, bamboo will hold up nicely.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "Illustration of cherry wood.",
      "src": "image/Cherry_Wood.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1 boardtext"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Cherry: ")]), _vm._v("Pick this if you’re looking for rich, red undertones for your board. The grain is tighter and finer and has an even texture. Cherry one of the best all-around woods for regular wear and tear. However, it doesn’t have any natural moisture protection, and direct sunlight can damage it if it’s exposed for prolonged periods.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "Illustration of olive wood.",
      "src": "image/Olive_Wood.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1 boardtext"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Olive: ")]), _vm._v("My personal favorite! Olive wood is incredibly beautiful, and with rich colors and uniquely fine-textured grain, it conveys a certain level of prestige. A creamy, golden wood with a very uniform pattern and color, olive is unmatched by other options. But beware—it’s not for the faint of heart. Olive wood is much more expensive and has a lower durability than other woods, since it lacks necessary natural oils to protect its quality.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "Illustration of teak wood.",
      "src": "image/Teak_Wood.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1 boardtext"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Teak: ")]), _vm._v("This wood is environmentally friendly and known for its elegance and durability. It’s water resistant and has an abundance of natural oils, which naturally protect its integrity. However, with its longevity and sustainability comes a higher price tag.")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-36",
    attrs: {
      "alt": "Photo of marble.",
      "src": "image/Marble.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead boardtext"
  }, [_vm._v("Marble")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1 boardtext"
  }, [_vm._v("There is something about this natural stone that brings me so much joy. It’s sleek and inviting, and it really adds an upscale sophistication to your board. Marble boards also photograph nicely, but you’ll want to be careful to avoid ingredients that could stain—it happens quickly! Marble can be a bit pricey, too, so it’s important to preserve its condition properly. ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "Illustration of slate.",
      "src": "image/Slate.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead boardtext"
  }, [_vm._v("Slate")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1 boardtext"
  }, [_vm._v("The dark gray color of slate contrasts beautifully with the vibrant colors of cheeses, fruits, and charcuterie. A slate board also allows for a bit of fun and creativity. Since its surface is like a chalkboard, you can easily decorate, illustrate, or label all your offerings—so your friends who aren’t fond of stinky cheese don’t reach for the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Camembert. I recommend using soapstone instead of regular chalk for labeling since it doesn’t create any dust and is safe to consume. ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "Photo of plates with arranged food.",
      "src": "image/DSC03213_P2.jpg"
    }
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "Heading-4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Hopeless Hostess Tip")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text"
  }, [_vm._v("No board, no problem! If you’re strapped for cash or looking to do something a little less traditional, you can still serve delicious spreads. Try using antique plates for a more eclectic vibe, or even slap some parchment paper down on your kitchen table! Whichever surface you choose, just make sure you’re considering the food you’ll be serving, how much space you’ll need, and the story you’re trying to tell with your food.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "bpink"
  }, [_c('h2', {
    staticClass: "Heading-2"
  }, [_vm._v("The Accessories")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Aside from the board itself, there are some other items that you’ll want to have on hand when you’re hosting. Stylish utensils, dippers, and ramekins pull everything together and play a key role in building a jaw-dropping food display. Here are a few of my favorites. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Honey Dipper")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Ah, the beloved honey dipper! This one is an absolute must-have and a big hit at every party. If you have honey on your board, opt to serve it neatly and beautifully with a wood or gold-tone stainless steel dipper. A honey dipper not only is an adorable touch to your board but also reduces the waste that comes from spooning gobs of honey onto your plate. The crevices of the dipper keep the honey from accumulating, and if you keep it spinning, the honey won’t drip until you’re ready to use it. A drizzle is all you need!")]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Ramekins")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Ramekins or tiny bowls are perfect for holding honey, jam, nuts, briny olives and cornichons, and zingy pickled red onions (see "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Pickled Red Onions")]), _vm._v("). They can also add texture and dimension to your spread. Depending on the size of the board and the size of your ramekins, you will likely only need one to three of them. They should be able to hold 2 to 3 ounces. Buy a matching set if you want a uniform, refined look, or purchase mismatched ramekins that fit your needs and board theme. If a guest has a food allergy, ramekins are a great way to separate tricky ingredients from the rest of the board.")]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Cheese Knives & Other Cheese Tools")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("When it comes to cheese knives, I can’t tell you how many times a party guest has asked me: “What the heck is this for?” Just like a chef uses various knives for different ingredients, there are different knives for different kinds of cheese. The following is by no means a comprehensive list—and I’ll discuss cheeses in more detail soon—but here’s a quick cheat sheet on how to use some of the most common cheese tools you’ll come across.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-29",
    attrs: {
      "alt": "Photo of cheese fork.",
      "src": "image/Cheese_Fork.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Cheese Fork: ")]), _vm._v("While not a knife, it’s almost always included in any cheese knife set because it has many purposes. The two pointed prongs are great for picking up sliced cheese or other accoutrements, like cornichons, fruits, and vegetables. It also comes in handy when you need to hold a hard cheese in place as you use the chisel knife to slice off a piece.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-30",
    attrs: {
      "alt": "Photo of a cheese plane.",
      "src": "image/Cheese_Plane.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Cheese Plane: ")]), _vm._v("With its spatula-like paddle, the cheese plane is used to shave off thin slices of semisoft cheeses, like young Gouda, fontina, and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Comté. It’s great if you want consistently thin, even pieces to eat or use on top of salads, crostini, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-31",
    attrs: {
      "alt": "Photo of a chisel knife.",
      "src": "image/Chisel_Knife.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Chisel Knife: ")]), _vm._v("Also known as a flat knife, this knife’s elongated blade on the top is used to cut aged, semihard cheeses, like "), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Asiago, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Gruyère, and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("provolone. Hold the blade over the top of the cheese and push down.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-32",
    attrs: {
      "alt": "Photo of a parmesan knife.",
      "src": "image/Parmesan_Knife.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Parmesan Knife: ")]), _vm._v("Imagine having an entire knife dedicated to you—that’s how amazing "), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Parmesan is! (I’ll go into why it’s my favorite cheese ever a little later.) Because of its shape, it’s also referred to as a heart knife, pear knife, or spade knife. It features a pointed tip and sharp, long edge for digging into hard cheeses, like Parmesan and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("Grana Padano.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-33",
    attrs: {
      "alt": "Photo of a plane knife.",
      "src": "image/Plane_Knife.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Plane Knife: ")]), _vm._v("Sometimes called a narrow plane knife or trapezium knife, this tool is great for semihard cheeses, like cheddar, Gouda, and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("Emmentaler. While it’s similar to the chisel knife in how it’s used, this knife tends to be more rectangular and offers two sharp sides instead of one. Press down on the cheese block with the top of the knife, then slice again using the side for a smaller piece.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-34",
    attrs: {
      "alt": "Photo of a pronged knife.",
      "src": "image/Pronged_Knife.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Pronged Knife: ")]), _vm._v("This knife, also referred to as forked-tipped spear, is very versatile. The blade is thin and has a small surface area, which allows you to slice a softer cheese without it sticking. The prong makes it easy to pick up your piece and transfer it to your plate. Use this knife for soft to semihard cheeses anywhere on the scale, from Camembert to Parmesan.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-35",
    attrs: {
      "alt": "Photo of a spreader.",
      "src": "image/Spreader.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Spreader: ")]), _vm._v("This one is pretty self-explanatory. Also known as a spatula knife, a spreader has a dull edge and rounded blade, which is perfect for soft, spreadable cheeses, like "), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Gorgonzola or Brie.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer053"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of a wire slicer.",
      "src": "image/Wire_Slicer.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Wire Slicer: ")]), _vm._v("This is an absolute must-have for me! It can be difficult to get a slice of delicate, soft cheese without squishing it from the pressure of the knife, but a wire slicer can save the day. Push down ever so gently to get a clean slice from the softer cheeses, like mozzarella and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("goat cheese (chèvre).")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-13",
    attrs: {
      "alt": "Photo of various utensils.",
      "src": "image/Accessories_P.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Various Serving Utensils")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Offering your guests a way to easily pick up food without using their hands is always a good (and sanitary) idea. I’ve found that having a go-to collection of serving utensils takes a lot of the guesswork out of setting up, making it a breeze. These are a few utensils I always keep on hand.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Cocktail Sticks/Toothpicks:")]), _vm._v(" Stylish charcuterie picks are perfect for just about anything on a board, plus they can double as an eating utensil so guests don’t have to eat with their fingers. Simply use disposable wooden toothpicks or find specialty picks that match your theme online or at your favorite home goods retailer.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Petite Spoons:")]), _vm._v(" These are nice to have for scooping jams and other "), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("spreadables. A teaspoon is perfect for smaller ramekins of jam or olive spread, and a tablespoon works well for your larger dips, like hummus, vegetable dip, etc. Using petite spoons with shorter handles makes the board look less cluttered while still being functional.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Tongs: ")]), _vm._v("These are great to have for nearly everything on your board. Invest in a set of beautiful, classic walnut tongs for something you can use time and time again. If your board is traveling with you to a party, consider bringing some disposable bamboo tongs. They’re environmentally friendly and super cute. Hang them over the side of a mason jar for an organized display.")]), _vm._v(" "), _c('h4', {
    staticClass: "Heading-4"
  }, [_vm._v("Hopeless Hostess Tip")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_2-column"
  }, [_vm._v("While the overall ambiance sets the scene for any event, your accessories can be used to pull the entire look together. I love a uniform look, which lets the beauty of the ingredients shine, but mismatched items—like those vintage spoons your mom has stashed in the basement—can really make a statement! Sourcing items from thrift stores and discount stores like "), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("HomeGoods is a great way to start your collection without breaking the bank. But keep in mind that too many competing colors and patterns could leave your board feeling cluttered and chaotic.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "bpink"
  }, [_c('h2', {
    staticClass: "Heading-2"
  }, [_vm._v("The Ingredients ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("One of my favorite things about cheese, charcuterie, and snack boards is how creative you can get when deciding what to serve. But it can be overwhelming to know where to start. From prepared foods to seasonal produce to the leftovers that have been sitting around in your fridge, you can make the most of what you have on hand. The following are some of my favorite items to use on boards, but these lists are meant to be guides and thought-starters for you. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-14",
    attrs: {
      "alt": "Photo of cheese and crackers.",
      "src": "image/Chevre_with_Edible_Flowers_P.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Cheese")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("It’s a big cheesy world out there with a lot to consider—different origins, flavors, textures "), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v(". . . the list goes on. To get you started, here’s a crash course in cheese that highlights a few things I think are important to know as a beginner. Everything I’ve learned about cheese has come from people far more knowledgeable. If you’re looking to learn more, I recommend seeking out resources by those with  a depth of knowledge in the space. ")]), _vm._v(" "), _c('p', {
    staticClass: "smallhead"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Fresh")])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("(Burrata, Feta, Cotija, Goat Cheese) ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Fresh cheese is essentially cheese in its youngest form, made of cheese curds that haven’t been pressed or aged. It’s rindless and bright white in color and offers a smooth and creamy texture. It’s typically fairly mild in flavor, which makes it great for salads, spreading over toast, mixing into sauces, and more. Make sure to enjoy them within a few days of purchasing.")]), _vm._v(" "), _c('p', {
    staticClass: "smallhead"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Soft-Ripened")]), _c('strong', {
    staticClass: "Bold-lead-in2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("(Brie, Camembert, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v(" Fromager d’Affinois, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Humboldt Fog) ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Soft-ripened cheeses have a “bloomy rind,” which adds a level of complexity and texture that makes the flavor special. Repeat after me: You. Can. Eat. The. Rind. Soft-ripened cheeses are often described as having a buttery, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("mushroomy, and creamy flavor profile. Due to the nature of their soft, creamy interior, you’ll typically see themserved in wedges or as a full wheel, with the rind encasing the cheese to provide stability. Enjoy these with any board, on a sandwich, or in your "), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("mac ’n’ cheese (like my "), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cracker-Crusted Baked Mac & Brie")]), _vm._v(" recipe).")]), _vm._v(" "), _c('p', {
    staticClass: "smallhead"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Semisoft ")]), _c('br'), _vm._v("(Fontina, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("Havarti, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("Muenster, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("Jarlsberg)")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Semisoft cheese is smooth and creamy. Most of these cheeses have a milder flavor, so they’re a great option for picky eaters. Because of their high moisture content, they’re great for melting but can be difficult to slice or shred at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "smallhead"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Semihard")]), _vm._v(" "), _c('br'), _vm._v("(Cheddar, Swiss, Gouda, Gruyère)")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("The perfect balance of aridity and moisture is what gives these cheeses their firmer consistency. They are aged anywhere from one to six months, which means a milder flavor than a longer-aged cheese, but the aging process still creates a concentrated rich, buttery flavor. Semihard cheeses are also an excellent option for melting . . . I’m talking an epic grilled cheese like the ones on my fancy grilled-cheese board (see "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gourmet Grilled Cheese & Tomato Soup")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "smallhead"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Blue-Veined ")]), _c('br'), _vm._v("(Danish Blue, Gorgonzola,"), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v(" Roquefort)")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Blue-veined cheeses are also semisoft, but I think they deserve their own category (and a lot of experts think so too!) because of their deliciously pungent flavor and unique characteristics. The “blue vein” comes from the mold Penicillium, which creates greenish-gray or blue lines throughout the cheese. There are all types of blue cheese: some are made from sheep’s or goat’s milk, but it is most commonly made using cow’s milk. ")]), _vm._v(" "), _c('p', {
    staticClass: "smallhead"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Hard")]), _vm._v(" "), _c('br'), _vm._v("("), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v("Parmigiano-Reggiano, Pecorino Romano, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v("Manchego)")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("As you might assume from the name, hard cheese is very firm in texture. This cheese is aged anywhere from six to thirty-six months, which heavily impacts the intensity of the flavor profile. Longer-aged cheeses such as these will have less moisture and begin to form natural crystals, which I like to expertly refer to as flavor bombs, and is my absolute favorite aspect of cheese and why I love Parmigiano-Reggiano so dearly. The rinds, while typically too hard to eat, can impart great flavor and umami to recipes, like soups and sauces.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of various labeled cheeses.",
      "src": "image/page11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of blueberries.",
      "src": "image/page13.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Fresh Fruits & Veggies")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Using fresh in-season produce packs a huge punch! It not only tastes better but also has higher nutritional value, is more environmentally friendly, and is typically more affordable. Plus, the colors are so pretty! You can’t go wrong with fresh produce, but a few of my go-tos include grapes, berries of all kinds, citrus, figs, cucumbers, cherry tomatoes, carrots, and radishes. Take a peek at my quick reference guide to "), _c('a', {
    attrs: {
      "href": "#/00_ArtOfTheBoard#_idTextAnchor036"
    }
  }, [_vm._v("Seasonal Produce")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Carbs & Crunchy Things")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Always offer an assortment of artisanal crackers and fresh bread to accompany your beautiful boards! While crackers are really just vehicles for cheese (in my humble opinion), they can elevate the flavors, textures, and colors of a spread. I use a lot of flavored crackers on my boards because I love the way different seasonings pair with cheese. I like to use herby crackers with fresh cheeses and sweet, fruity ones with earthier aged cheeses, but feel free to use your favorites. I know they can take up a lot of room, so if you want to save space on the board for cheese and charcuterie, opt to make a carb board (see "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Creative with Your Carbs & Crackers")]), _vm._v(") on the side for your crackers and bread.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Crunch from both crackers and things like nuts add a textural element that completes every bite, so be sure to always include some on your board. I’m a big fan of pistachios, almonds, walnuts, the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Nuts")]), _vm._v(", and the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Spiced Nuts")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "Photo of labeled cured meats.",
      "src": "image/page12.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Charcuterie ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Charcuterie (shaar-koo-tuh-ree) is just a fancy way of saying cured meats. The word derives from fifteenth-century France, where instead of letting their leftover meat go to waste, they would cure it to preserve it without refrigeration. Nowadays, in addition to the meat itself, the word "), _c('em', {
    staticClass: "Emphasis"
  }, [_vm._v("charcuterie")]), _vm._v(" is used loosely to describe a cheese and cured meat board. While this is technically correct (since these boards do have cured meats), it’s important to understand the nuances of the word. For example, my "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afternoon Pick-Me-Up")]), _vm._v(" board would be a cheese board, and my "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’more, Please!")]), _vm._v(" board would be a snack board, since neither offer cured meats. ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Some of the charcuterie you’ll find on these boards include: "), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v("Genoa salami (cured pork sausage), chorizo (smoky cured sausage), "), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v("bresaola (air-dried beef), "), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("coppa (air-dried pork), "), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v("prosciutto (dry-cured Italian ham), "), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v("calabrese (spicy cured salami), "), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v("soppressata (dry salami), mortadella (original bologna), and "), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v("p"), _c('span', {
    attrs: {
      "lang": "ar-SA",
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("âté")]), _vm._v(" (meat paste).")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-17",
    attrs: {
      "alt": "Photo of store bought and prepared items.",
      "src": "image/DSC03234_P.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Store-Bought & Prepared Items")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Not everything on your board needs to be from scratch! While I share some recipes throughout the book for homemade items that would work great on your boards, there is no shame in the store-bought game. You’ll find a lot of store-bought and prepared ingredients in this book. Why? Because it’s easier! The last thing anyone wants is a stressed-out host! If you’re pressed for time or just aren’t the type to whip up a batch of jam, hummus, chicken salad, or baked goods, add them to your grocery list.")]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Garnishes & Finishing Touches")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("You eat with your eyes first, right? If we’re going through all this trouble to pick the perfect ingredients, then we better make our finished product Instagram-worthy! (More on this in "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do It for the ’Gram!")]), _vm._v(".) ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Garnishes and finishing touches can cover any blank spots on your board, add visual appeal, elaborate on your theme, and ultimately pull the entire spread together. In addition to gorgeous pops of color, fresh herbs and leafy greens can really elevate a bite! Topping a slice of mozzarella with fresh basil is always a winner, and the bitterness of leafy greens can help complement the sweetness of fruits and the richness of cheeses.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Edible flowers are guaranteed to surprise and delight your guests. But it’s not only their eye-catching colors and intoxicating fragrance that makes them special—they can also add an unexpected and exciting flavor to your bite! You can typically find these at your local florist or farmers market, but if you’re having trouble, you can also find them online (see "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edible Flowers & Herbs")]), _vm._v(" for where I purchase mine) and have them shipped right to your door. I love using marigolds, lavender, pansies, chamomile, honeysuckle, daylily, or squash blossoms. Make sure to taste your flowers to ensure that their flavor complements the cheeses on your board, and then place them next to or on their respective pairings to help guide your guests.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("You should also consider a few decorative items that might add a little excitement or flare. For example, plan a few days ahead for New Year’s Eve and splurge on some edible gold flakes (see "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ring In the New Year")]), _vm._v("). Use a fun cookie cutter to shape your soft cheese. Or add googly eyes to make your Halloween board a little spookier (see "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toil & Treats")]), _vm._v("). I’ve even used a pair of plastic sunglasses on a board before. (Yes, it is as strange as it sounds. Check out my "), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v("Friends Reunion Special Board on my Instagram to see what I mean!)")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Above all, never feel like you "), _c('em', {
    staticClass: "Emphasis"
  }, [_vm._v("have")]), _vm._v(" to buy specialty items to have a unique board—what makes each one special is the time and effort you put into it! Because of this, I do my best to provide easy alternatives wherever possible.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-18",
    attrs: {
      "alt": "Photo of flowers and other garnishes.",
      "src": "image/DSC03208_P.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Heading-4_Idented"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v("Hopeless Hostess Tip")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_2-column"
  }, [_vm._v("Produce is at its best when it’s grown and harvested in season. In-season produce is widely available and affordable—it also tastes better, which increases the overall appeal of your board. The following reference list will help you select produce on your board, but always remember that item availability is dependent on your region and growing season. Produce availability will vary.")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_ListH"
  }, [_c('span', {
    staticClass: "Listed-Season-Name _idGenCharOverride-2"
  }, [_vm._v("Spring ")])]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Apricots")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Artichokes")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Asparagus")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Avocados")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Broccoli rabe")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Chives")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Collards")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Mangos")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Pineapples")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Rhubarb")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Snap peas, snow peas & pea pods")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Strawberries")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_ListH"
  }, [_c('span', {
    staticClass: "Listed-Season-Name _idGenCharOverride-2"
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Bell peppers")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Blackberries")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Blueberries")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Broccoli")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Champagne grapes")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Cherries")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Cucumbers")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Gooseberries")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Green beans")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Mangos")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Nectarines")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Peaches")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Plums")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Raspberries")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Watermelon")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Zucchini")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_ListH"
  }, [_c('span', {
    staticClass: "Listed-Season-Name _idGenCharOverride-2"
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Apples")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Butternut squash")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Carrots")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Cauliflower")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Cranberries")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Edamame")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Figs")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Gourds")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Grapes")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Mushrooms")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Pears")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Pomegranate")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Pumpkins")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Quince")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Sweet potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Swiss chard")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_ListH"
  }, [_c('span', {
    staticClass: "Listed-Season-Name _idGenCharOverride-2"
  }, [_vm._v("Winter ")])]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Chestnuts")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Clementines")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Grapefruit")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Kale")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Lemons")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Mandarins")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Oranges")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Radicchio")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Radishes")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Rutabagas")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Tangerines")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Turnips")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_List"
  }, [_vm._v("Winter squash")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-16",
    attrs: {
      "alt": "Photo of figs.",
      "src": "image/DSC03282_P.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "bpink"
  }, [_c('h2', {
    staticClass: "Heading-2"
  }, [_vm._v("Building Your Board")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Now that we’ve talked about what you’ll need, let’s get to the fun part! Assembling the board is where your creativity gets to shine. The following steps are how I approach building a traditional cheese board, and this section provides the basic reasons behind the where and why. ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("You’ll also want to keep in mind a few ground rules as you develop your artfully designed board. First, think about the occasion you’re attending and tailor your board to the event. How many people will be there? How big should your board be?")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Next, remember to maintain balance across the board with regard to design and ingredients. If you have a lot of green on one side, try to match that on the other side. Create a balance of cheese, meat, produce, and dips throughout the board so one component doesn’t overpower the others.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-19",
    attrs: {
      "alt": "Photo of food and boards.",
      "src": "image/Addtl_Crumb_Shot_P.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Last, try your best not to overcrowd or clutter your board. Great boards are made up of hand-selected ingredients that pair well together. I know it’s easy to go overboard with so many enticing options to choose from, but try to refrain from making your board look like you’ve emptied out the entirety of your fridge and pantry.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("For some easy ways to elevate your presentation, look at my tips in the "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hopeless Hostess Appendix")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "buildboard"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-20",
    attrs: {
      "alt": "Photo of empty board.",
      "src": "image/DSC03284.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Step 1: Choose your board")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("A few things to consider when selecting the base for your masterpiece: How many people are you feeding? Are you traveling with your board? Will any of your selections stain? You can choose more than one surface, if needed.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "buildboard"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-21",
    attrs: {
      "alt": "Photo of board with ramekins added.",
      "src": "image/DSC03286.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Step 2: Place your ramekins or small bowls")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("It’s easy to forget these once you get going, and you’ll want to make sure you save space for dips, honey, jam, briny items, etc. Two per board is typically enough, but you can increase the number if you’re using a larger surface area.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "buildboard"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-22",
    attrs: {
      "alt": "Photo of board with cheese added.",
      "src": "image/DSC03291.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Step 3: Add your cheeses")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("This helps make sure that you reserve the prime real estate for the good stuff! Add your styled cheese, making sure any hard cheeses are sliced for easy grabbing. A rule of thumb is to serve 3 ounces of cheese per person for an appetizer and more for a meal.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "buildboard"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-23",
    attrs: {
      "alt": "Photo of board with larger produce added.",
      "src": "image/DSC03295.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Step 4: Place larger produce")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("These foods will be tough to squeeze in later, so it’s good to get them on the board early. They create a base layer to build upon when you add some of the filler items in step 7.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "buildboard"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-24",
    attrs: {
      "alt": "Photo of board with carbs added.",
      "src": "image/DSC03299.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Step 5: Add your carbs")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("A handful of crackers or slices of bread add texture and color variation, but it’s best to limit the amount of space you devote to them to save room for other things.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "buildboard"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-25",
    attrs: {
      "alt": "Photo of board with charcuterie added.",
      "src": "image/DSC03300.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Step 6: Layer your charcuterie")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Layer in your charcuterie next. The rule of thumb is 2 ounces of meat per person for an appetizer and more for a meal. Two to three different kinds of meat provide a nice assortment for your guests to choose from.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "buildboard"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-26",
    attrs: {
      "alt": "Photo of completed board.",
      "src": "image/DSC03303.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Step 7: Fill in the gaps")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("The final touches! Fill any open spaces with smaller produce, nuts, and other garnishes or bits.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "Heading-4_Idented"
  }, [_vm._v("Hopeless Hostess Tip")]), _vm._v(" "), _c('p', {
    staticClass: "Hopeless-Hostess-text_2-column"
  }, [_vm._v("Before you get to building your board, take a moment to think about your vision. Your spread can reflect the flavors, textures, and pairings that you love, or you can allow yourself to become inspired by your favorite holiday, color combination, television show, or cuisine to create something special. Are you celebrating a birthday? Think about some of the guest of honor’s favorite foods. Hosting your annual Independence Day party? Brainstorm something red, white, and blue, like my Fourth of July board (see "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red, White & Berries")]), _vm._v("). Having a viewing party for "), _c('em', {
    staticClass: "Skew"
  }, [_vm._v("The Bachelor")]), _vm._v("? Include fresh roses or shoot your shot at making the beloved "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charcuterie Rose")]), _vm._v(". Whatever the occasion, consider the experience you’re trying to create for your guests and let your board bring that to life. Don’t be afraid to step out of your comfort zone!")])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "Heading-1"
  }, [_vm._v("Using This Book")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1_DC"
  }, [_c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("W")]), _vm._v("e’re almost there! Now that we’re inching closer to getting our hands dirty, let’s take a moment to explore how you can make this book work for you. Think of it as peeking behind the curtain of my brain to understand why I’ve labeled, categorized, and organized the book the way that I have.")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "bpink"
  }, [_c('h2', {
    staticClass: "Heading-2"
  }, [_vm._v("The Boards")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("As I’ve mentioned before, these boards are meant to be a guide to creating your own perfect version, and I’ve given you some basic information to help get you started, like measurements, difficulty le-vel, expected investment, dietary labels, and more. I think these are some of the most important factors to consider when building a board. With this information readily available before you start, you’ll be able to easily identify which boards are going to work for your event, schedule, and wallet!")])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Ingredient Amounts")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Each board in this book includes approximate ingredient amounts to give an idea of how much to purchase or whether you happen to have enough on hand already, but your dream spread will depend on your specific creative vision and practical needs. The size and shape of your board, how many people you’re feeding, and your food preferences all affect how much of something you’ll wind up using. However, a good baseline is 3 ounces of cheese per person and 2 ounces of meat per person. Really, you can’t go wrong, so don’t stress too much about the snacks!")]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Seasonality")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("The changing of seasons, celebrating holidays, and gathering for events drives inspiration and sparks creativity when it comes to hosting, so I organized the boards by season: spring, summer, fall, and winter. The memories and feelings we’re able to cultivate through food are so powerful, and I love that each and every season offers different ways to bring us around the table to share laughs, stories, and most important, delicious food.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Some boards are related to my own experiences, and some are aligned to holidays or events, like the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oktoberfest")]), _vm._v(" board. Others are more universal and instead highlight seasonal ingredients (which can be repurposed throughout the year with a few simple substitutions), like the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summertime Citrus, Mozzarella & Prosciutto")]), _vm._v(" board.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Keep in mind that the seasonality of some ingredients could affect their availability. For example, some of the Christmas-themed boards use spiced cheeses or sweets that are only available in the wintertime. But if you can’t find a specific ingredient, use your best judgment and personal preference to select a substitution that will pair well with the other elements on the board.")]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Allergens & Other Dietary Needs")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Each board is labeled with the following icons so you can easily find spreads that fit your needs. For quick-reference lists of meat-free boards, easy weekight meals, and other culinary considerations, turn to "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Board for All Occasions Quick Guide")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of dietary icons.",
      "src": "image/page23.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Investment")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("One huge factor when creating a board is your budget. If you’ve ever made a snack board before, you know firsthand how quickly those items can add up! For this reason, I call out the approximate investment for each board. However, if you see a board that you’d like to make that is out of your price range, don’t sweat it! You can always substitute some of the pricier items for extra veggies, fruits, snack mixes, etc. Please be aware that these are just estimates and the actual amounts will vary, depending on where you live and where you shop. For my favorite wallet-friendly snack boards, turn to "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under $40")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-15",
    attrs: {
      "alt": "Photo of cost icons.",
      "src": "image/page23b.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Ch1-Subhead"
  }, [_vm._v("Difficulty")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("Each board in this book has been assigned a difficulty rating—not to entice or discourage you from making one board over another but to mentally prepare you for the time and effort required. Some days we have more time than others to expertly fold salami! These indicators help you understand how involved a board might be so you can choose accordingly. For a handy list of boards that can be made in under 20 minutes, check out "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under 20 Minutes")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of easy level of difficulty icon.",
      "src": "image/page24easy.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v(" Easy: ")]), _vm._v("These boards should take you 30 minutes or less. They use mostly store-bought prepared ingredients and require little to no home cooking. The techniques used are fairly simple and won’t require much practice to master. If you’re totally new to snack boards, give "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bountiful Berries")]), _vm._v(" a try.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of intermediate level of difficulty icon.",
      "src": "image/page24intermediate.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v(" Intermediate:")]), _vm._v(" Like the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultimate Taco Tuesday")]), _vm._v(" board, these should take around 45 minutes. They use some store-bought prepared ingredients, but you’ll also have to do some cooking. The techniques aren’t difficult or cumbersome, but they might require you to spend some time practicing your folding or slicing before plating.")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of difficult level of difficulty icon.",
      "src": "image/page24difficult.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_c('strong', {
    staticClass: "Bold-lead-in2"
  }, [_vm._v("Difficult:")]), _vm._v(" Don’t shy away from the more difficult boards! While they may take you an hour or more to assemble, they are absolute showstoppers. (Feast your eyes on the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ooey-Gooey Fondue-y")]), _vm._v(" board.) They might use a few prepared ingredients, but they require you to spend more time in the kitchen whipping up components. The techniques are a little more sophisticated, which will take more time to master. These boards may also include items that require you to purchase them online in advance, like the witch’s cauldron on the Halloween-themed "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toil & Treats")]), _vm._v(". ")]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "bpink"
  }, [_c('h2', {
    staticClass: "Heading-2"
  }, [_vm._v("The Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("I’ve included a handful of my favorite recipes throughout the book. Some of them are included within the boards themselves, like the Brie Brûlée on the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fall Harvest")]), _vm._v(" board, and others are stand-alone recipes gathered in chapter 6, like the snack-board staples "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Nuts")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Hummus")]), _vm._v(". Feel free to pick and choose how you incorporate them into your boards, if you do at all. For example, if you think the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elote Dip")]), _vm._v(" would work well on the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultimate Taco Tuesday")]), _vm._v(" board, add it to the list! ")]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-27",
    attrs: {
      "alt": "Photo of mexican corn.",
      "src": "image/Mexican_Street_Corn_2.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "bpink"
  }, [_c('h2', {
    staticClass: "Heading-2"
  }, [_vm._v("The Extras")]), _vm._v(" "), _c('p', {
    staticClass: "TXT1"
  }, [_vm._v("If you picked up this book to learn how to assemble fun and fancy snack boards, you’re in the right place! But there’s so much more in here for you, too. These pages are packed full of ideas on how to elevate your next soiree beyond your board.")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("I share my super fun cocktail recipes (the "), _c('span', {
    attrs: {
      "href": "#/01_Art_Of_The_Board#_idTextAnchor132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autumn Harvest Punch")]), _vm._v(" photo is below), favorite flavor combinations (so you can impress your friends!), and tips and tricks for styling your food. There’s even a "), _c('span', {
    attrs: {
      "href": "#/02_ArtOfTheBoard#_idTextAnchor137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hopeless Hostess Appendix")]), _vm._v(" that covers everything you need to know about prepping, styling, and more! ")]), _vm._v(" "), _c('p', {
    staticClass: "TXT"
  }, [_vm._v("Ultimately, my goal in sharing all this information is to leave you in the most capable hands . . . your own! Through these boards, recipes, tips, and tricks, I want you to feel empowered to harness your passion and create something beautiful. Although this book is filled with ways to use a special event or holiday to inspire you, remember that a board can come together on a whim and without a theme, expensive ingredients, or elaborate decor. This is your reminder to allow the small things to fill your cup—or should I say board? Be creative, be adventurous (and yes, that means you should try the blue cheese), and most important, be proud of the edible piece of art you’ve created.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-28",
    attrs: {
      "alt": "Photo of autumn punch.",
      "src": "image/Autumn_Harvest_Punch_Pfront.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56544cfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/00_ArtOfTheBoard.vue
// module id = 57
// module chunks = 0